import { render, staticRenderFns } from "./CarTableMovements.vue?vue&type=template&id=a31a59f0&scoped=true"
import script from "./CarTableMovements.vue?vue&type=script&lang=ts"
export * from "./CarTableMovements.vue?vue&type=script&lang=ts"
import style0 from "./CarTableMovements.vue?vue&type=style&index=0&id=a31a59f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31a59f0",
  null
  
)

export default component.exports